import Close from '~/icons/close.svg';
import React from 'react';
import { useTranslation } from '~/shared/utils/translation';
import { ResetButton } from '~/shared/components/Button/ResetButton';
import styles from './CloseBanner.module.scss';
import styled from '@emotion/styled';

const StyledCloseButton = styled(ResetButton)<{ textColor: string }>`
    svg path {
        fill: ${(props) => props.textColor};
    }
`;

type Props = { textColor: string; onCloseBanner?: () => void };
export const CloseBanner = (props: Props) => {
    const { translate } = useTranslation();
    return (
        <StyledCloseButton
            onClick={props.onCloseBanner}
            className={styles.closeButton}
            title={translate('header.closeBanner')}
            aria-label={translate('header.closeBanner')}
            textColor={props.textColor}
        >
            <Close />
        </StyledCloseButton>
    );
};
